import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

interface ModalBaseState {
    visible: boolean;
    visibleSecondary: boolean;
}

const initialState: ModalBaseState = {
    visible: false,
    visibleSecondary: false,
}

export const modalBaseSlice = createSlice({
    name: 'modalBase',
    initialState,
    reducers: {
        setVisible: (state, action) => {
            state.visible = action.payload;
        },
        setVisibleSecondary: (state, action) => {
            state.visibleSecondary = action.payload;
        },
    },
});

export const selectVisible = (state: RootState) => state.modalBase.visible;
export const selectVisibleSecondary = (state: RootState) => state.modalBase.visibleSecondary;

export const { setVisible, setVisibleSecondary } = modalBaseSlice.actions;

export default modalBaseSlice.reducer;